import { jsx as _jsx } from "react/jsx-runtime";
import { getAllowedOrderItemModifierQuantity, getInheritedPriceForItemModifier, getItemById, updateInProgressItemModifiers } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useCallback, useContext } from 'react';
import { useOccContext } from '../../../context/occ/hooks/use-occ-context';
import { ItemPickerContextInstance } from '../types/context';
import { getFormattedPriceForModifier } from '../utils/get-formatted-price-for-modifier';
import { getQuantityInputType } from '../utils/get-quantity-input-type';
import { ItemPickerItemOption } from './item-option';
const b = bemClassBuilder('v-item-picker-modifier-group');
export const ItemPickerModifierGroup = observer(props => {
    const { i18n, displayText: { price: priceDisplayText } } = useOccContext();
    const { modifierGroup, baseItem } = props;
    const { quantityLimit } = modifierGroup;
    const { config } = useContext(ItemPickerContextInstance);
    const { showImages } = config.normalItemModifiers;
    const handleModifierQuantityUpdate = useCallback((newQuantity, modifier) => {
        const inheritedPrice = getInheritedPriceForItemModifier(baseItem, modifier);
        updateInProgressItemModifiers(modifierGroup.id, quantityLimit, newQuantity, modifier.itemId, inheritedPrice);
    }, [baseItem, modifierGroup, quantityLimit]);
    return (_jsx("ul", Object.assign({ className: b.block() }, { children: modifierGroup.modifiers.map(modifier => {
            const item = getItemById(modifier.itemId);
            const allowedQuantity = getAllowedOrderItemModifierQuantity(modifierGroup, modifier.itemId);
            if (!item)
                throw new Error(`Cannot find modifier item with ID: ${modifier.itemId}`);
            return (_jsx(ItemPickerItemOption, { item: item, quantityInputType: getQuantityInputType(quantityLimit), allowedQuantity: allowedQuantity, showImage: showImages, onQuantityUpdate: newQuantity => handleModifierQuantityUpdate(newQuantity, modifier), formattedOptionPrice: getFormattedPriceForModifier(baseItem, modifier, priceDisplayText.discountedPriceFormat, i18n) }, modifier.itemId));
        }) })));
});
ItemPickerModifierGroup.displayName = 'ItemPickerModifierGroup';
